module.exports = __webpack_public_path__ + "static/media/autumn-che-routes@2x.f9e2bcc1.png";